module.exports = __webpack_public_path__ + "img/logo-app-ufabet.ed93ad38.png";